module.exports = __webpack_public_path__ + "static/media/artists.60e50770.svg";